import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { OfflineModeStateService } from "../../offline/offline-mode-state.service";

/**
 * DEV-966 (CA 04) — barra permanente enquanto o Modo Offline estiver ligado. Só informa o estado;
 * o andamento da sincronização (que acontece ao desligar o modo) fica no `OfflineSyncToastComponent`.
 */
@Component({
  selector: "app-offline-mode-banner",
  standalone: true,
  templateUrl: "./offline-mode-banner.component.html",
  styleUrl: "./offline-mode-banner.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfflineModeBannerComponent {
  private readonly state = inject(OfflineModeStateService);

  public readonly visible = this.state.enabled;
}
